const BankingCard = () =>
  import(
    /* webpackChunkName: "BankingCard" */ "@/components/AccountPage/Banking/BankingCard/index"
  );

const BankingSheba = () =>
  import(
    /* webpackChunkName: "BankingSheba" */ "@/components/AccountPage/Banking/BankingSheba/index"
  );

export default {
  name: "banking",
  components: { BankingCard, BankingSheba },
  props: [],
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {}
};
